
export const category = {
    laptops: {
        id: 1,
        title: "Laptops in Pakistan",
        MetaTitle: "Laptops Prices in Pakistan - Used Laptop Price in Pakistan",
        MetaDescription: "Explore the latest laptops price in Pakistan and buy laptops in Pakistan at Techbazaar. Find top brands, great deals, and unbeatable offers today!",


    },
    mobiles: {
        id: 2,
        title: "Mobile Phones with Prices in Pakistan",
        MetaTitle: "Mobile Price in Pakistan - Latest Mobile Phones Price in Pakistan",
        MetaDescription: "Discover the best deals for online mobile shopping in Pakistan at TechBazaar. Browse top brands and buy mobile in Pakistan at unbeatable prices today!",
        MetaKeywords: "Mobiles in Pakistan, Mobile Prices in Pakistan, Mobile Phone Prices in Pakistan, Mobile Phone Prices, Mobile Phones with Prices in Pakistan, Mobiles and Prices in Pakistan, Mobiles with Prices in Pakistan, Mobile Phone Pakistan, Mobile Price in Pakistan, New mobile phone prices, latest mobile phones, new mobiles price in pakistan, Pakistan mobile price, Pakistan price mobile, pak mobile price,new mobile price in pakistan, new mobile price, new mobile phones price in pakistan, new mobile phones price, mobile with price in pakistan, mobile price, mobile phones in pakistan price, mobile phone price in pakistan, mobile new price, latest mobile price in pakistan, all mobile price in pakistan"
    },
    tablets: {
        id: 3,
        title: "Tablet Prices in Pakistan",
        MetaTitle: "Tablet Price in Pakistan - Buy Tablets Online",
        MetaDescription: "Shop Apple, Xiaomi, Huawei, Lenovo, and Samsung tablets at Techbazaar. Find the best prices and a wide range of options to suit your needs in Pakistan."
    },
    "led-monitors": {
        id: 4,
        title: "Monitors and LED Tv Prices in Pakistan",
        MetaTitle: "Monitor Price in Pakistan | LED TV Price in Pakistan",
        MetaDescription: "Find the latest monitor and LED TV prices in Pakistan. Shop top brands and great deals for home and office use!"
    },
    desktops: {
        id: 5,
        title: "Computer Prices in Pakistan",
        MetaTitle: "PC Price in Pakistan - Gaming PC",
        MetaDescription: "Find the best price of computers in Pakistan, including personal computers for gaming. Shop high-performance PCs at great deals for gaming and everyday use"

    },
    accessories: {
        id: 6,
        title: "Computer & Mobile Accessories ",
        MetaTitle: "Mobile Accessories | Accessories for Computer",
        MetaDescription: "Shop top mobile accessories and accessories of computer at Techbazaar.pk. Find phone cases, chargers, keyboards, mice, and more at great prices!"

    },
};

// subCategoryData.ts
export const subCategoryData = {
    accessories: {
        others: {
            "ronin-smart-watches": {
                category_type_id: 26,
                brand_id: 63,
                title: "Ronin Smart Watches in Pakistan",
                MetaTitle: "Ronin Smart Watch Price in Pakistan",
                MetaDescription:"Explore Ronin smartwatches at Techbazaar. Shop top-quality, stylish, and feature-packed Ronin watches for every need."
            },
            "ronin-power-banks": {
                category_type_id: 8,
                brand_id: 63,
                title: "Ronin Power Banks in Pakistan",
                MetaTitle: "Ronin Power Bank Price in Pakistan",
                MetaDescription:"Buy high-capacity Ronin power banks at Techbazaar. Choose from 10,000mAh and 20,000mAh models for reliable, long-lasting charging on the go."
            },
            "ronin-handsfree": {
                brand_id: 63,
                category_type_id: 59,
                title:"Buy Ronin Handsfree ",
                MetaTitle:"Ronin Handsfree Price in Pakistan",
                MetaDescription:"Shop Ronin handsfree and Ronin Type-C handsfree at Techbazaar. Superior sound quality and comfort with these high-performance, durable audio accessories."
            },
            "hp-printers-in-pakistan": {
                category_type_id: 28,
                brand_id: 28,
                title: "HP Printers in Pakistan",
                MetaDescription: "Explore a wide selection of HP printers in Pakistan at Techbazaar. Shop for reliable and high-performance HP printers to suit your printing needs.",
                MetaTitle:"HP Printer Price in Pakistan"

            },
            "xiaomi-power-banks": {
                category_type_id: 8,
                brand_id: 4,
                title: "Shop Xiaomi Mi Power Banks",
                MetaTitle: "Mi Power Bank Price in Pakistan | Xiaomi Power Bank",
                MetaDescription:"Shop Mi power banks at Techbazaar. Choose from 10,000mAh and 20,000mAh models for fast, reliable charging on the go with Mi's high-performance power banks."

            },
            "faster-power-banks": {

                category_type_id: 8,
                brand_id: 68,
                title: "Buy Faster Power Banks ",
                MetaTitle:"Faster Power Bank Price in Pakistan",
                MetaDescription: "Shop faster power banks at Techbazaar for quick and efficient charging. Buy high-performance power banks that keep your devices powered up in no time.",
                

            },
            "iphone-chargers": {
                brand_id: 3,
                category_type_id: 10,
                title: "Shop iPhone Chargers",
                MetaTitle: "iphone Charger Price in Pakistan | Adaptor for iphone",
                MetaDescription:"Shop for iPhone charger and original iPhone charger at Techbazaar. Get reliable, fast charging solutions for your iPhone with top-quality accessories."



            },
            "samsung-chargers": {
                brand_id: 2,
                category_type_id: 10,
                title: "Shop Samsung Chargers",
                MetaTitle:"Samsung Charger Price in Pakistan",
                MetaDescription:"Shop Samsung chargers and Samsung adapters at Techbazaar. Find fast, reliable charging solutions for your Samsung devices at competitive prices."
            },
            "ronin-chargers": {
                brand_id: 63,
                category_type_id: 10,
                title: "Shop Ronin Chargers",
                MetaTitle: "Ronin Charger Price in Pakistan",
                MetaDescription:"Shop Ronin charger and Ronin fast chargers at Techbazaar. Enjoy quick and efficient charging with high-quality Ronin charging solutions for your devices."
            }



        },


        types: {
            smartwatches: {
                id: 26,
                title: "Smart Watches",
                MetaTitle: "Smart Watches Price In Pakistan",
                MetaDescription: "Discover the latest smart watches in Pakistan, including top touch watches. Shop for sleek, functional, and affordable smartwatches at Techbazaar.pk."
            },
            powerbanks: {
                id: 8,
                MetaTitle: "Power Banks Price in Pakistan",
                MetaDescription: "Explore a variety of power banks in Pakistan at affordable prices. Find the best power banks for your devices with long-lasting battery life at Techbazaar.pk.",
                title: "Buy Mobile Power Banks in Pakistan"


            },
            chargers: {
                id: 10,
                title: "Shop Mobile Phone Chargers in Pakistan",
                MetaDescription: "Shop for mobile chargers and faster chargers at Techbazaar.pk. Find high-quality, quick-charging solutions for your devices at affordable prices in Pakistan.",
                MetaTitle: "Mobile Charger Price in Pakistan"



            },
            earphones: {
                id: 20,
                title: "Earbuds Price in Pakistan",
                MetaTitle: "Ear Buds Price in Pakistan - Wireless Earbuds",
                MetaDescription: "Discover the best AirPods price in Pakistan and a variety of earbuds in Pakistan at Techbazaar. Enjoy high-quality sound and comfort at affordable prices."
            },
            headphones: {
                id: 19,
                title: "Headphones in Pakistan",
                MetaTitle: "Wireless Headphones Price in Pakistan",
                MetaDescription: "Shop the best Bluetooth headphones and wireless headphones at Techbazaar. Find high-quality, comfortable, and durable options for all your listening needs."
            },
            "printers": {
                id: 28,
                title: "Printers in Pakistan",
                MetaTitle: "Printers Price in Pakistan",
                MetaDescription:"Find the best computer printer price in Pakistan at Techbazaar. Shop a wide range of printers and buy the perfect one for your needs at affordable prices."

            },
            "bluetooth-speakers": {

                id: 17,
                title: "Bluetooth Speakers in Pakistan",
                MetaTitle: "Bluetooth Speaker Price in Pakistan",
                MetaDescription:"Shop high-quality Bluetooth speakers at Techbazaar. Enjoy powerful sound and wireless convenience with our loudspeaker with Bluetooth."
            }
        },
        brands: {
            "ronin-accessories-price-in-pakistan": {
                id: 63,
                title: "Buy Ronin Accessories",
                MetaTitle: "Ronin Smart Wearable & Tech Accessories",
                MetaDescription: "hop Ronin accessories at Techbazaar.pk. Find premium wearables, wireless earbuds, Bluetooth headphones, and more designed to enhance your experience."

            },
            "login-accessories-price-in-pakistan": {
                id: 145,
                title: "Buy Login Accessories",
                MetaTitle: "Login Online Mobile Accessories",
                MetaDescription: "Discover Login accessories at Techbazaar.pk. Shop for wearables, Bluetooth earbuds, and accessories that provide seamless and secure online access."
            },
            "faster-accessories-price-in-pakistan": {
                id: 68,
                title: "Buy Faster Accessories",
                MetaTitle: "Faster Wearables & Accessories in Pakistan",
                MetaDescription: "Buy Faster accessories at Techbazaar.pk. Explore Bluetooth earbuds, wireless headphones, wearables, and more designed for enhanced performance and speed."
            },
            "apple-accessories-price-in-pakistan": {
                id: 3,
                title: "Buy Apple Accessories ",
                MetaTitle: "Shop Apple Wearables, Earbuds & Bluetooth Accessories",
                MetaDescription: "Find premium Apple accessories at Techbazaar.pk. Shop for wearables, Bluetooth earbuds, wireless headphones, and more for your iPhone, iPad, and MacBook."
            },
        },
        city: {
            "buy-accessories-in-lahore": {
                id: 1,
                title: "Computer & Accessories for Sale in Lahore",
                MetaTitle: "Buy Computer and Mobile Accessories in Lahore",
                MetaDescription: "Shop mobile & computer accessories in Lahore at Techbazaar.pk. Find great deals and fast delivery on quality accessories for sale in Lahore."
            },
            "buy-accessories-in-multan": {
                id: 6,
                title: "Computer & Accessories for Sale in Multan",
                MetaTitle: "Buy Computer and Mobile Accessories in Multan",
                MetaDescription: "Explore mobile & computer accessories in Multan at Techbazaar.pk. Get top-quality accessories for sale in Multan with fast delivery."
            },
            "buy-accessories-in-faisalabad": {
                id: 9,
                title: "Computer & Accessories for Sale in Faisalabad",
                MetaTitle: "Buy Computer and Mobile Accessories in Faisalabad",
                MetaDescription: "Shop mobile & computer accessories in Faisalabad at Techbazaar.pk. Find great deals on accessories for sale in Faisalabad with quick delivery."
            },

            "buy-accessories-in-rawalpindi": {
                id: 7,
                title: "Computer & Accessories for Sale in Rawalpindi",
                MetaTitle: "Buy Computer and Mobile Accessories in Rawalpindi",
                MetaDescription: "Shop for mobile & computer accessories in Rawalpindi at Techbazaar.pk. Buy accessories for sale in Rawalpindi with fast delivery options."
            },
            "buy-accessories-in-karachi": {
                id: 3,
                title: "Computer & Accessories for Sale in Karachi",
                MetaTitle: "Buy Computer and Mobile Accessories in Karachi",
                MetaDescription: "Explore mobile & computer accessories in Karachi at Techbazaar.pk. Get top accessories for sale in Karachi with fast and reliable delivery."
            },
        },
    },


    mobiles: {
        gaming: {
            "gaming-phones-in-pakistan": {
                id: [102, 290, 544, 500, 564, 366, 34],
                MetaTitle: " Gaming Phones Price in Pakistan",
                MetaDescription: "Explore top mobiles for gaming at TechBazaar. Find the best gaming phones with powerful performance and immersive features for an ultimate gaming experience",
                title: "Gaming Mobile Phones in Pakistan"
            },
        },
        network: {
            "5g-phones-in-pakistan": {
                id: 8,
                MetaTitle: "5G Mobile Price in Pakistan ",
                MetaDescription: "Shop the latest 5G mobiles in Pakistan at TechBazaar. Explore top brands offering fast connectivity and advanced features. Get your 5G mobile today!",
                title: "5G Mobile Phones in Pakistan"
            }

        },

        camera: {
            "best-camera-phones-in-pakistan": {
                id: [6, 12, 20],
                MetaTitle: "Buy Phones With The Best Camera",
                MetaDescription: "Discover phones with the best camera at TechBazaar. Shop the top smartphones with advanced camera features for stunning photos and videos!",
                title: "Best Camera Smart Phones in Pakistan"
            }
        },
        brands: {
            "apple-mobiles-price-in-pakistan": {
                id: 3,
                title: "Prices of Iphone in Pakistan",
                MetaTitle: "Iphone Price in Pakistan - Buy iphone",
                MetaDescription: "Check the latest iPhone mobiles price in Pakistan at TechBazaar. Buy iPhone with top features, exceptional performance, and great deals available now!",
                MetaKeywords: "iPhone Price in Pakistan, Buy iPhone, Apple mobiles price Pakistan, iPhone mobile phones, Apple mobile deals",
            },
            "redmi-mobiles-price-in-pakistan": {
                id: 4,
                title: "Redmi Mobiles Prices in Pakistan",
                MetaTitle: "Redmi Mobile Price in Pakistan - Buy Xiaomi Mobiles",
                MetaDescription: "Looking to buy a Xiaomi Redmi mobile in Pakistan? Explore the latest models and competitive prices available across top online retailers.",
                MetaKeywords: "Redmi mobile price Pakistan, Buy Redmi Mobiles, Xiaomi mobile Pakistan, Redmi phones Pakistan, Xiaomi Redmi deals",
            },
            "infinix-mobiles-price-in-pakistan": {
                id: 21,
                title: "Infinix Mobiles Prices in Pakistan",
                MetaTitle: "Infinix Mobile Price in Pakistan - Buy Infinix Mobiles",
                MetaDescription: "The latest Infinix new model at TechBazaar. Check out Infinix mobile prices in Pakistan and find the best deals on top smartphones.",
                MetaKeywords: "Infinix mobile price Pakistan, Buy Infinix mobiles, Infinix new models, Infinix smartphone prices, Infinix deals Pakistan",
            },
            "samsung-mobiles-price-in-pakistan": {
                id: 2,
                title: "Samsung Mobiles Prices in Pakistan",
                MetaTitle: "Samsung Mobile Price in Pakistan - Samsung New Model",
                MetaDescription: "Check the latest Samsung mobiles price in Pakistan. Buy Samsung mobiles with top features, performance, and great value, all at competitive prices.",
                MetaKeywords: "Samsung mobile price Pakistan, Buy Samsung mobiles, Samsung new models, Samsung smartphones Pakistan, Samsung mobile deals",
            },
            "vivo-mobiles-price-in-pakistan": {
                id: 17,
                title: "Vivo Mobiles Prices in Pakistan",
                MetaTitle: "Vivo New Model - Vivo Mobile Price in Pakistan",
                MetaDescription: "Check the latest Vivo mobiles price in Pakistan. Buy Vivo mobiles with advanced features, great performance, and unbeatable value at competitive prices.",
                MetaKeywords: "Vivo mobile price Pakistan, Buy Vivo mobiles, Vivo new models, Vivo smartphones Pakistan, Vivo mobile deals",
            },
            "oppo-mobiles-price-in-pakistan": {
                id: 6,
                title: "Oppo Mobiles Prices in Pakistan",
                MetaTitle: "Oppo Mobile Price in Pakistan - Buy Oppo Mobiles",
                MetaDescription: "Check the latest Oppo mobiles price in Pakistan. Buy Oppo mobiles online with top features, great performance, and unbeatable prices at TechBazaar.",
                MetaKeywords: "Oppo mobile price Pakistan, Buy Oppo mobiles, Oppo new models, Oppo smartphones Pakistan, Oppo mobile deals",
            },
            "techno-mobiles-price-in-pakistan": {
                id: 23,
                title: "Tecno Mobiles Prices in Pakistan",
                MetaTitle: "Tecno Mobile Price in Pakistan - Tecno New Model",
                MetaDescription: "Check the latest Tecno mobiles price in Pakistan and explore the Tecno new model with advanced features and great performance at affordable prices.",
                MetaKeywords: "Tecno mobile price Pakistan, Buy Tecno mobiles, Tecno new models, Tecno smartphones Pakistan, Tecno mobile deals",
            },
            "itel-mobiles-price-in-pakistan": {
                id: 34,
                title: "Itel Mobiles Prices in Pakistan",
                MetaTitle: "Itel Mobile Price in Pakistan - Buy Itel Mobiles",
                MetaDescription: "Check the latest ITEL mobile prices in Pakistan and buy ITEL mobiles online. Get budget-friendly smartphones with great features.",
                MetaKeywords: "Itel mobile price Pakistan, Buy Itel mobiles, Itel smartphones Pakistan, Itel mobile phones, Itel deals Pakistan",
            },
            "realme-mobiles-price-in-pakistan": {
                id: 5,
                title: "Realme Mobiles Prices in Pakistan",
                MetaTitle: "Realme Mobile Price in Pakistan - Buy Realme Mobiles",
                MetaDescription: "Check the latest Realme price in Pakistan. Explore top Realme smartphones with advanced features and great value, all available at competitive prices.",
                // MetaKeywords: "Realme mobile price Pakistan, Buy Realme mobiles, Realme new models, Realme smartphones Pakistan, Realme mobile deals",
            },
            "nokia-mobiles-price-in-pakistan": {
                id: 8,
                title: "Nokia Mobiles Prices in Pakistan",
                MetaTitle: "Nokia Mobile Price in Pakistan - Nokia New Models",
                MetaDescription: "Check the latest Nokia mobile prices and buy Nokia mobiles online. Explore top Nokia smartphones with great features and unbeatable value for your money.",
                // MetaKeywords: "Nokia mobile price Pakistan, Buy Nokia mobiles, Nokia new models, Nokia smartphones Pakistan, Nokia mobile deals",
            },
        },
        city: {
            "buy-mobiles-in-lahore": {
                id: 1,
                title: "Mobiles for Sale in Lahore",
                MetaTitle: "Mobile phones for sale in Lahore",
                MetaDescription: "Find the best mobile price in Lahore at TechBazaar. Browse top smartphones from leading brands at competitive prices and great value in Lahore.",
                MetaKeywords: "Mobile phones for sale in Lahore, Mobile price in Lahore, Mobile price Lahore, Mobile sale in Lahore, Mobiles for sale Lahore, Mobiles sale in Lahore, Mobile phone price Lahore, Mobile phone price in Lahore, Mobile for sale Lahore, Mobile for sale in Lahore",
            },
            "buy-mobiles-in-multan": {
                id: 6,
                title: "Mobiles for Sale in Multan",
                MetaTitle: "Mobile Phones for Sale in Multan",
                MetaDescription: "Explore the latest mobile price in Multan at TechBazaar. Shop from a wide selection of smartphones with top features, all at competitive prices in Multan.",
                MetaKeywords: "Mobile phones for sale in Multan, Mobile price in Multan, Mobile price Multan, Mobile sale in Multan, Mobiles for sale Multan, Mobiles sale in Multan, Mobile phone price Multan, Mobile phone price in Multan, Mobile for sale Multan, Mobile for sale in Multan",
            },
            "buy-mobiles-in-faisalabad": {
                id: 9,
                title: "Mobiles for Sale in Faisalabad",
                MetaTitle: "Mobile Phones for sale in Faisalabad",
                MetaDescription: "Check out the best mobile price in Faisalabad at TechBazaar. Discover top smartphones with amazing features & prices in Faisalabad.",
                MetaKeywords: "Mobile phones for sale in Faisalabad, Mobile price in Faisalabad, Mobile price Faisalabad, Mobile sale in Faisalabad, Mobiles for sale Faisalabad, Mobiles sale in Faisalabad, Mobile phone price Faisalabad, Mobile phone price in Faisalabad, Mobile for sale Faisalabad, Mobile for sale in Faisalabad",
            },
            "buy-mobiles-in-rawalpindi": {
                id: 7,
                title: "Mobiles for Sale in Rawalpindi",
                MetaTitle: "Mobile Phones for Sale in Rawalpindi",
                MetaDescription: "Explore the latest mobile price in Rawalpindi at TechBazaar. Find top smartphones with excellent features and unbeatable prices, all available in Rawalpindi.",
                MetaKeywords: "Mobile phones for sale in Rawalpindi, Mobile price in Rawalpindi, Mobile price Rawalpindi, Mobile sale in Rawalpindi, Mobiles for sale Rawalpindi, Mobiles sale in Rawalpindi, Mobile phone price Rawalpindi, Mobile phone price in Rawalpindi, Mobile for sale Rawalpindi, Mobile for sale in Rawalpindi",
            },
            "buy-mobiles-in-karachi": {
                id: 3,
                title: "Mobiles for Sale in Karachi",
                MetaTitle: "Mobile Phones for Sale in Karachi",
                MetaDescription: "Check the latest mobile price in Karachi at TechBazaar. Explore a wide range of smartphones from top brands at competitive prices, all available in Karachi.",
                MetaKeywords: "Mobile phones for sale in Karachi, Mobile price in Karachi, Mobile price Karachi, Mobile sale in Karachi, Mobiles for sale Karachi, Mobiles sale in Karachi, Mobile phone price Karachi, Mobile phone price in Karachi, Mobile for sale Karachi, Mobile for sale in Karachi",
            },
        },
        price: {
            "buy-mobiles-under-20000": {
                id: 20000,
                title: "Phones Under 20000 in Pakistan",
                MetaTitle: "20000 Range Mobile in Pakistan - Best Mobile Under 20000",
                MetaDescription: "Shop the best mobile under 20000 in Pakistan at TechBazaar. Explore top smartphones with great features, reliable performance, and affordable prices today!",
                MetaKeywords: "phones under 20000 in Pakistan, mobile phones under 20000, mobile phones under 20000 in Pakistan, mobile phone under 20000 in Pakistan, good mobile under 20000, best phones under 20000 in Pakistan,best, phone under 20000 in Pakistan, best mobile under 20 000, best mobile under 20000 in Pakistan",

            },
            "buy-mobiles-under-30000": {
                id: 30000,
                title: "Phones Under 30000 in Pakistan",
                MetaTitle: "Best Mobile Under 30000 in Pakistan - Phone Under 30k",
                MetaDescription: "Looking for a mobile under 30000 in Pakistan? Buy from a wide range of affordable 30000 range mobiles in Pakistan at Techbazaar.",
                MetaKeywords: "mobile under 30000, Mobile under 30000 in Pakistan, best mobiles under 30000, top mobiles under 30000, best mobiles under 30000 Pakistan, best mobiles under 30000,30000 range mobile in Pakistan",

            },
            "buy-mobiles-under-40000": {
                id: 40000,
                title: "Phones Under 40000 in Pakistan",
                MetaTitle: "Phones Under 40000 in Pakistan - Buy Mobiles Below 40000",
                MetaDescription: "Explore the best mobile range 40000 in Pakistan at TechBazaar. Shop top smartphones under 40000 with great features, performance, and unbeatable prices!",
                MetaKeywords: "best mobiles under 40000, top mobiles under 40000, best mobiles under 40000 Pakistan, mobiles under 40000 in Pakistan, phones under 40000 in Pakistan, under 40000 best mobile, mobile under 40000 in Pakistan, mobile range 40000, mobile phones, under 40000 in Pakistan, mobile phone under 40000 in Pakistan",

            },
            "buy-mobiles-under-50000": {
                id: 50000,
                title: "Phones Under 50000 in Pakistan",
                MetaTitle: "Best Phones Under 50000 in Pakistan - Buy Phone Under 50k",
                MetaDescription: "Shop the best 50000 range mobile in Pakistan at TechBazaar. Buy mobile under 50k with top features, excellent performance, and great value for your money!",
                MetaKeywords: "phones under 50000 in Pakistan, mobile phones under 50000, mobile phones under 50000 in Pakistan, mobile phone under 50000 in Pakistan, good mobile under 50000, best phones under 50000 in Pakistan, best phone under 50000 in Pakistan, best mobile under 50000, best mobile under 50000 in Pakistan, phone under 50000 in Pakistan, mobile under 50000 in pakistan,50000 range mobile in pakistan",

            },
            "buy-mobiles-under-60000": {
                id: 60000,
                title: "Phones Under 60000 in Pakistan",
                MetaTitle: "Best Mobile Under 60000 in Pakistan",
                MetaDescription: "Find the best phones under 60000 in Pakistan at TechBazaar. Shop top smartphones with advanced features, excellent performance.",
                MetaKeywords: "Best mobile under 60000 in Pakistan,Best phone under 60000 in Pakistan,Phones under 60000 in Pakistan,Mobile phones under 60000 in Pakistan,Best mobile under 60000,Mobile phones under 60000",
            },
            "buy-mobiles-under-70000": {
                id: 70000,
                title: "Phones Under 70000 in Pakistan",
                MetaTitle: "Best Mobile Under 70000 in Pakistan",
                MetaDescription: "Find the best phone under 70000 in Pakistan with top features and great performance at TechBazaar.",
                MetaKeywords: "Best Mobile Under 70000 in Pakistan,best phone under 70000 in Pakistan,best phones under 70000 in Pakistan,phones under 70000 in Pakistan,best mobile under 70000",
            },
            "buy-mobiles-under-80000": {
                id: 80000,
                title: "Phones Under 80000 in Pakistan",
                MetaTitle: "Best Phones Under 80000 in Pakistan",
                MetaDescription: "Explore a wide selection of mobiles under 80000 in Pakistan at TechBazaar. Find top smartphones with excellent features.",
                MetaKeywords: "Best mobile under 80000 in Pakistan, Best phone under 80000 in Pakistan, Best phones under 80000 in Pakistan, Phones under 80000 in Pakistan, Best mobile under 80000",
            },
            "buy-mobiles-under-90000": {
                id: 90000,
                title: "Phones Under 90000 in Pakistan",
                MetaTitle: "Best Phones Under 90000 in Pakistan",
                MetaDescription: "Browse the best mobiles under 90000 in Pakistan at TechBazaar. Discover smartphones with advanced features & high performance.",
                MetaKeywords: "Best mobile under 90000 in Pakistan, Best phone under 90000 in Pakistan, Best phones under 90000 in Pakistan, Phones under 90000 in Pakistan, Best mobile under 90000",
            },
            "buy-mobiles-under-100000": {
                id: 100000,
                title: "Phones Under 100000 in Pakistan",
                MetaTitle: "Best Phones Under 100000 in Pakistan",
                MetaDescription: "Find the best mobiles under 100000 in Pakistan at TechBazaar. Explore smartphones with premium features & excellent performance",
                MetaKeywords: "Best mobile under 100000 in Pakistan, Best phone under 100000 in Pakistan, Best phones under 100000 in Pakistan, Phones under 100000 in Pakistan, Best mobile under 100000",
            },
        },
    },


    laptops: {
        types: {
            "gaming-laptops-in-pakistan": {
                id: 20,
                title: "Gaming Laptops In Pakistan",
                MetaTitle: "Gaming Laptops Price in Pakistan ",
                MetaDescription: "Explore the best gaming laptops in Pakistan at Techbazaar. Discover top brands, powerful performance, and unbeatable prices for gaming laptops.",
            },
            "Convertible-laptops-in-pakistan": {
                id: [16, 13],
                title: "Convertible Laptops In Pakistan",
                MetaTitle: "Convertible Laptops Price in Pakistan ",
                MetaDescription: "Check out the latest convertible laptops in Pakistan on Techbazaar. Find top convertible laptops with great features and unbeatable prices."
            },
            "Workstation-laptops-in-pakistan": {
                id: 23,
                title: "Workstation Laptops In Pakistan",
                MetaTitle: "Workstation Laptops Price in Pakistan ",
                MetaDescription: "Find the best workstation laptops in Pakistan on Techbazaar. Shop for top-rated laptops with great performance and features at unbeatable prices."
            }
        },
        brands: {
            "dell-laptops-price-in-pakistan": {
                id: 25,
                title: "Dell Laptops Price in Pakistan",
                MetaTitle: "Dell Laptops Prices in Pakistan",
                MetaDescription: "Browse Dell laptops with prices in Pakistan and buy Dell laptops at Techbazaar. Explore top models, great features, and unbeatable deals today!"
            },
            "hp-laptops-price-in-pakistan": {
                id: 28,
                title: "HP Laptops Price in Pakistan",
                MetaTitle: "Hp Laptops Prices in Pakistan",
                MetaDescription: "Check out laptop prices in Pakistan HP and buy HP laptops at Techbazaar. Find top HP models, great features, and the best deals today!"
            },
            "lenovo-laptops-price-in-pakistan": {
                id: 13,
                title: "Lenovo Laptops Price in Pakistan",
                MetaTitle: "Lenovo Laptops Prices in Pakistan",
                MetaDescription: "Find the best Lenovo laptop prices in Pakistan. Explore a wide range of Lenovo laptops at affordable prices, only at Techbazaar."

            },
            "apple-laptops-price-in-pakistan": {
                id: 3,
                title: "Macbook Price in Pakistan",
                MetaTitle: "MacBook Prices in Pakistan",
                MetaDescription: "Find the best MacBook prices in Pakistan. Explore a wide range of MacBooks at affordable prices, only at Techbazaar."
            },
            "acer-laptops-price-in-pakistan": {
                id: 35,
                title: "Acer Laptops Price in Pakistan",
                MetaTitle: "acer laptops prices in pakistan",
                MetaDescription: "Find the best Acer laptop prices in Pakistan. Explore a wide range of Acer laptops at affordable prices, only at Techbazaar."
            },
        },
        city: {

            "buy-laptops-in-lahore": {
                id: 1,
                title: "Laptops in Lahore",
                MetaTitle: "Laptops for Sale in Lahore - Laptop Prices in Lahore",
                MetaDescription: "Explore the best laptops in Lahore and discover the latest laptop prices in Lahore at Techbazaar. Get great deals on top brands and models today!"
            },
            "buy-laptops-in-multan": {
                id: 6,
                title: "Laptops in Multan",
                MetaTitle: "Laptops for Sale in Multan - Laptop Prices in Multan",
                MetaDescription: "Buy laptops in Multan and explore a wide range of laptops in Multan at Techbazaar. Get the best deals on top brands and models today!"
            },
            "buy-laptops-in-faisalabad": {
                id: 9,
                title: "Laptops in Faisalabad",
                MetaTitle: "Laptops for Sale in Faisalabad - Laptop Price Faisalabad",
                MetaDescription: "Check the latest laptop prices in Faisalabad and buy laptops in Faisalabad at Techbazaar. Explore top brands and get the best deals today!"
            },
            "buy-laptops-in-rawalpindi": {
                id: 7,
                title: "Laptops in Rawalpindi",
                MetaTitle: "Laptop Prices in Rawalpindi - Laptop for Sale Rawalpindi",
                MetaDescription: "Find laptops for sale in Rawalpindi and explore a wide range of laptops in Rawalpindi at Techbazaar. Get the best deals on top brands and models today!"
            },
            "buy-laptops-in-karachi": {
                id: 3,
                title: "Laptops in Karachi",
                MetaTitle: "Laptops for Sale in Karachi - Laptop Rates in Karachi",
                MetaDescription: "Find the best used laptops in Karachi and check the latest laptop prices in Karachi at Techbazaar. Shop for top brands and great deals today!"
            }
        },
        price: {
            "buy-laptops-under-50000": {
                id: 50000,
                title: "Laptops Under 50000 in Pakistan",
                MetaTitle: "Best Laptop Under 50k in Pakistan",
                MetaDescription: "Explore the best laptops under 50000 in Pakistan at Techbazaar. Discover affordable yet high-performance laptops that meet your needs and budget."
            },
            "buy-laptops-under-100000": {
                id: 100000,
                title: "Laptops Under 100000 in Pakistan",
                MetaTitle: "Best Laptop Under 100k in Pakistan",
                MetaDescription: "Find the best laptops under 100000 in Pakistan on Techbazaar. Shop for top-rated laptops with great performance and features at unbeatable prices."
            },
            "buy-laptops-under-200000": {
                id: 200000,
                title: "Laptops Under 200000 in Pakistan",
                MetaTitle: "Best Laptop Under 200k in Pakistan",
                MetaDescription: "Discover the best laptops under 200000 in Pakistan at Techbazaar. Shop for high-end laptops with excellent performance, design, and value."
            },
            "buy-laptops-under-300000": {
                id: 300000,
                title: "Laptops Under 300000 in Pakistan",
                MetaTitle: "Best Laptop Under 300k in Pakistan",
                MetaDescription: "Shop the best laptops under 300000 in Pakistan on Techbazaar. Find premium laptops with powerful specs and advanced features at the best prices."
            }
        },
        generation: {
            "8th-generation-laptops-in-pakistan": {
                id: 16,
                title: "8th Generation Laptops In Pakistan",
                MetaTitle: "8th Generation Laptops Price Pakistan",
                MetaDescription: "Find the latest Acer, Asus, Dell, HP, Lenovo, Toshiba, MSI, and Alienware 8th Gen laptops at the lowest prices in Pakistan, exclusively at Techbazaar."
            },
            "9th-generation-laptops-in-pakistan": {
                id: 17,
                title: "9th Generation Laptops In Pakistan",
                MetaTitle: "9th Generation Laptops Price Pakistan",
                MetaDescription: "Explore the best deals on Acer, Asus, Dell, HP, Lenovo, Toshiba and Alienware 9th Gen laptops in Pakistan. Shop now at Techbazaar for unbeatable prices."
            },
            "10th-generation-laptops-in-pakistan": {
                id: 18,
                title: "10th Generation Laptops In Pakistan",
                MetaTitle: "10th Generation Laptop Price in Pakistan",
                MetaDescription: "Shop the latest Acer, Asus, Dell, HP, Lenovo, Toshiba, MSI, and Alienware 10th Gen laptops at Techbazaar. Get the lowest prices in Pakistan today!"
            },
            "11th-generation-laptops-in-pakistan": {
                id: 19,
                title: "11th Generation Laptops In Pakistan",
                MetaTitle: "11th Generation Laptop Price in Pakistan",
                MetaDescription: "Find the latest Acer, Asus, Dell, HP, Lenovo, Toshiba, MSI, and Alienware 11th Gen laptops at the best prices in Pakistan, only at Techbazaar."
            },
            "12th-generation-laptops-in-pakistan": {
                id: 20,
                title: "12th Generation Laptops In Pakistan",
                MetaTitle: "12th Generation Laptop Price in Pakistan",
                MetaDescription: "Discover the latest Acer, Asus, Dell, HP, Lenovo, Toshiba, MSI, and Alienware 12th Gen laptops at the lowest prices in Pakistan on Techbazaar."
            }
        },
        processors: {
            "intel-core-i3-laptops-in-pakistan": {
                id: 200,
                title: "Intel Core I3 Laptops In Pakistan",
                MetaTitle: "Core i3 Laptop Price in Pakistan",
                MetaDescription: "Discover the best i3 laptop price in Pakistan on Techbazaar. Shop for affordable Core i3 laptops with reliable performance and great deals."
            },
            "intel-core-i5-laptops-in-pakistan": {
                id: 201,
                title: "Intel Core I5 Laptops In Pakistan",
                MetaTitle: "Core i5 Laptop Price in Pakistan",
                MetaDescription: "Check out the latest Laptop price in Pakistan Core i5 on Techbazaar. Find powerful Core i5 laptops with great performance and amazing deals."
            },
            "intel-core-i7-laptops-in-pakistan": {
                id: 202,
                title: "Intel Core I7 Laptops In Pakistan",
                MetaTitle: "Core i7 Laptop Price in Pakistan",
                MetaDescription: "Explore the latest Laptop price in Pakistan Core i7 on Techbazaar. Shop for high-performance Core i7 laptops with top specs and great deals."
            },
            "Apple-m1-laptops-in-pakistan": {
                id: 365,
                "title": "Apple M1 Laptops In Pakistan",
                "MetaTitle": "MacBook M1 Price in Pakistan",
                "MetaDescription": "Find the best MacBook Pro M1 price in Pakistan on Techbazaar. Discover the powerful MacBook M1 with top performance and sleek design at great prices"
            }
        }

    },
    tablets: {
        brands: {
            "apple-tablets-price-in-pakistan": {
                id: 3,
                title: "IPads Prices in Pakistan",
                MetaTitle: "IPads Price in Pakistan",
                MetaDescription: "Find iPad prices in Pakistan. Explore the best deals on iPads in Pakistan. Techbazaar offers a wide range of iPads at great prices for every need.",

            },
            "xiaomi-tablets-price-in-pakistan": {
                id: 4,
                title: "Xiaomi Tablet Prices in Pakistan",
                MetaTitle: "Xiaomi Tablet Price in Pakistan",
                MetaDescription: "Find Xiaomi tablet prices in Pakistan. Explore the best rates for Xiaomi tablets in Pakistan. Techbazaar offers a wide selection of Xiaomi tablets at great prices.",

            },
            "huawei-tablets-price-in-pakistan": {
                id: 7,
                title: "Huawei Tab Prices in Pakistan",
                MetaTitle: "Huawei Tab Price in Pakistan",
                MetaDescription: "Discover Huawei tablet prices in Pakistan. Get the best deals for Huawei tablets in Pakistan. Shop a wide range of Huawei tablets at Techbazaar.",
            },
            "lenovo-tablets-price-in-pakistan": {
                id: 13,
                title: "Lenovo Tablet Prices in Pakistan",
                MetaTitle: "Lenovo Tablet Price in Pakistan",
                MetaDescription: "Check out Lenovo tablet prices in Pakistan and find the best rates. Techbazaar provides a variety of Lenovo tablets at affordable prices.",
            },
            "samsung-tablets-price-in-pakistan": {
                id: 2,
                title: "Samsung Tablet Prices in Pakistan",
                MetaTitle: "Samsung Tablet Price in Pakistan",
                MetaDescription: "Find Samsung tablet prices in Pakistan. Get the best rates for Samsung tablets in Pakistan. Techbazaar is go-to online shop with a vast variety of tablets."
            },
        },
        city: {
            "buy-tablets-in-lahore": {
                id: 1,
                title: "Buy Tablets In Lahore",
                MetaTitle: "Tablets for Sale in Lahore",
                MetaDescription: "Shop tablets for sale in Lahore at Techbazaar. Find the best deals on top tablet brands and models in Lahore today!"
            },
            "buy-tablets-in-multan": {
                "id": 6,
                title: "Buy Tablets In Multan",
                MetaTitle: "Tablets for Sale in Multan",
                MetaDescription: "Browse tablets for sale in Multan at Techbazaar. Explore a variety of tablets at great prices and find the perfect one for you in Multan."
            },
            "buy-tablets-in-faisalabad": {
                id: 9,
                title: "Buy Tablets In Faisalabad",
                MetaTitle: "Tablets for Sale in Faisalabad",
                MetaDescription: "Discover tablets for sale in Faisalabad at Techbazaar. Shop a wide selection of tablets at affordable prices in Faisalabad today."
            },
            "buy-tablets-in-rawalpindi": {
                id: 7,
                title: "Buy Tablets In Rawalpindi",
                MetaTitle: "Tablets for Sale in Rawalpindi",
                MetaDescription: "Find tablets for sale in Rawalpindi at Techbazaar. Get the best prices on top tablet brands and models in Rawalpindi."
            },
            "buy-tablets-in-karachi": {
                id: 3,
                title: "Buy Tablets In Karachi",
                MetaTitle: "Tablets for Sale in Karachi",
                MetaDescription: "Explore tablets for sale in Karachi at Techbazaar. Shop top tablet brands and get the best deals in Karachi today."
            }
        },
        price: {
            "buy-tablets-under-30000": {
                id: 30000,
                title: "Buy Tablets Under 30000",
                MetaTitle: "Tablets Under 30000 in Pakistan",
                MetaDescription: "Shop the best tablets under 30k in Pakistan at Techbazaar. Find affordable options with great features and performance at unbeatable prices."
            },
            "buy-tablets-under-50000": {
                id: 50000,
                title: "Buy Tablets Under 50000",
                MetaTitle: "Tablets Under 50000 in Pakistan",
                MetaDescription: "Explore top tablets under 50k in Pakistan at Techbazaar. Discover budget-friendly tablets with excellent performance and value for money."
            },
            "buy-tablets-under-60000": {
                id: 60000,
                title: "Buy Tablets Under 60000",
                MetaTitle: "Tablets Under 60000 in Pakistan",
                MetaDescription: "Browse tablets under 60k in Pakistan at Techbazaar. Find high-quality tablets offering great features and performance at competitive prices."
            },
            "buy-tablets-under-100000": {
                id: 100000,
                title: "Buy Tablets Under 100000",
                MetaTitle: "Tablets Under 100000 in Pakistan",
                MetaDescription: "Shop the best tablets under 100k in Pakistan at Techbazaar. Find premium tablets with advanced features and top-notch performance at great prices."
            },
        },
    },
    "led-monitors": {
        gaming: {
            "gaming-monitors-in-pakistan": {
                id: [15, 19, 14, 16, 17, 24],
                title: "Gaming Monitors in Pakistan",
                MetaTitle: "Gaming Monitors Price in Pakistan",
                MetaDescription: "Explore top monitors for gaming at TechBazaar. Shop the best gaming monitor in Pakistan for exceptional performance, sharp visuals, and smooth gameplay!"

            }

        },
        borderless: {
            "borderless-monitors-in-pakistan": {
                id: 17,
                title: "Borderless Monitors in Pakistan",
                MetaTitle: "Borderless Monitor Price in Pakistan",
                MetaDescription: "Shop borderless monitors in Pakistan at TechBazaar. Find sleek and stylish borderless monitors for sale, offering immersive visuals and a modern design!"


            }

        },
        brands: {
            "lenovo-led-monitors-price-in-pakistan": {
                id: 13,
                title: "Lenovo Monitors in Pakistan",
                MetaTitle: "Lenovo Monitors Price in Pakistan",
                MetaDescription: "Explore Lenovo monitors at the best prices in Pakistan. Find reliable and affordable options for work and entertainment.",
            },
            "dell-led-monitors-price-in-pakistan": {
                id: 25,
                title: "Dell Monitors in Pakistan",
                MetaTitle: "Dell Monitor Price in Pakistan",
                MetaDescription: "Check Dell monitor prices in Pakistan. Choose from a wide range of high-performance monitors for your home or office.",
            },
            "hp-led-monitors-price-in-pakistan": {
                id: 28,
                title: "HP Monitors in Pakistan",
                MetaTitle: "HP Monitors Price in Pakistan",
                MetaDescription: "Shop HP monitors at competitive prices in Pakistan. Discover top-quality monitors perfect for work and gaming setups.",
            },
            "samsung-led-monitors-price-in-pakistan": {
                id: 2,
                title: "Samsung Tv & Monitors in Pakistan",
                MetaTitle: "Samsung TV Price in Pakistan - Samsung Monitors",
                MetaDescription: "Get the latest Samsung TV and monitor prices in Pakistan. Shop high-quality models with excellent visuals and deals!",
            },
        },
        city: {
            "buy-led-monitors-in-lahore": {
                id: 1,
                title: "Buy Monitors In Lahore",
                MetaTitle: "Monitors for Sale in Lahore",
                MetaDescription: "Browse a wide selection of monitors for sale in Lahore. Find the best deals and top brands for home or office use in your area.",
            },
            "buy-led-monitors-in-multan": {
                id: 6,
                title: "Buy Monitors In Multan",
                MetaTitle: "Monitors for Sale in Multan",
                MetaDescription: "Shop monitors for sale in Multan at great prices. Discover high-quality monitors for work, gaming, and entertainment at affordable rates.",
            },
            "buy-led-monitors-in-faisalabad": {
                id: 9,
                title: "Buy Monitors In Faisalabad",
                MetaTitle: "Monitors for Sale in Faisalabad",
                MetaDescription: "Explore monitors for sale in Faisalabad. Find the latest models at great prices for your home or office. Shop now for the best deals.",
            },
            "buy-led-monitors-in-rawalpindi": {
                id: 7,
                title: "Buy Monitors In Rawalpindi",
                MetaTitle: "Monitors for Sale in Rawalpindi",
                MetaDescription: "Check out monitors for sale in Rawalpindi. Find top-rated monitors at competitive prices. Shop for your ideal monitor today!",
            },
            "buy-led-monitors-in-karachi": {
                id: 3,
                title: "Buy Monitors In Karachi",
                MetaTitle: "Monitors for Sale in Karachi",
                MetaDescription: "Find the best monitors for sale in Karachi. Browse top brands and affordable options for all your home or office needs.",
            },
        },
        price: {
            "buy-led-monitors-under-30000": {
                id: 30000,
                title: "Buy LED & Monitors Under 30000",
                MetaTitle: "Monitors Under 30000 in Pakistan",
                MetaDescription: "Discover monitors under 30,000 in Pakistan. Shop affordable and high-quality monitors for all your computing needs at great prices.",
            },
            "buy-led-monitors-under-50000": {
                id: 50000,
                title: "Buy LED & Monitors Under 50000",
                MetaTitle: "Monitors Under 50000 in Pakistan",
                MetaDescription: "Browse monitors under 50,000 in Pakistan. Get top brands and great deals on high-performance monitors for home or office use.",
            },
            "buy-led-monitors-under-60000": {
                id: 60000,
                title: "Buy LED & Led  Monitors Under 60000",
                MetaTitle: "Monitors Under 60000 in Pakistan",
                MetaDescription: "Explore monitors under 60,000 in Pakistan. Find premium options for work, gaming, and entertainment within your budget.",
            },
            "buy-led-monitors-under-100000": {
                id: 100000,
                title: "Buy LED & Led Monitors Under 100000",
                MetaTitle: "Monitors Under 100000 in Pakistan",
                MetaDescription: "Shop monitors under 100,000 in Pakistan. Discover high-end models with stunning visuals and performance for all your needs.",
            },
        },
    },

    desktops: {
        brands: {
            "dell-desktops-price-in-pakistan": {
                id: 25,
                title: "Dell Computer Prices in Pakistan",
                MetaTitle: "Dell PC Prices in Pakistan",
                MetaDescription: "Check the latest Dell CPU price in Pakistan and explore Dell computers. Find affordable options for work, gaming, and everyday use with great deals."
            },
            "hp-desktops-price-in-pakistan": {
                id: 28,
                title: "HP Computers Price in Pakistan",
                MetaTitle: "HP Computer Prices in Pakistan",
                MetaDescription: "Explore HP CPU prices in Pakistan and shop HP desktops for work, gaming, and home use. Find the best deals on reliable and high-performance computers."
            },
            "lenovo-desktops-price-in-pakistan": {
                id: 13,
                title: "Lenovo Computer Prices in Pakistan",
                MetaTitle: "Lenovo Computer Prices in Pakistan",
                MetaDescription: "Browse Lenovo CPU prices and explore Lenovo desktops for work, gaming, and home use. Find high-performance desktops at great prices in Pakistan."
            },
            "acer-desktops-price-in-pakistan": {
                id: 35,
                title: "Acer Computer Prices in Pakistan",
                MetaTitle: "Acer Computer Prices in Pakistan",
                MetaDescription: "Explore Acer CPU prices in Pakistan and shop Acer desktops for work, gaming, and home use. Find the best deals on reliable and high-performance computers."
            },
        },
        city: {
            "buy-desktops-in-lahore": {
                id: 1,
                MetaTitle: "Desktop PC for Sale in Lahore",
                MetaDescription: "Find the best CPU in Lahore and check computer price in Lahore. Explore top brands and affordable options for gaming, work, and home use.",
                title: "Computers in Lahore"
            },
            "buy-desktops-in-multan": {
                id: 6,
                MetaTitle: "Desktop PC for Sale in Multan",
                MetaDescription: "Browse CPU in Multan and discover computer price in Multan. Shop for high-performance computers at great prices for all your needs.",
                title: "Computers in Multan"
            },
            "buy-desktops-in-faisalabad": {
                id: 9,
                title: "Computers in Faisalabad",
                MetaTitle: "Desktop PC for Sale in Faisalabad",
                MetaDescription: "Browse CPU in Faisalabad and discover computer price in Multan. Shop for high-performance computers at great prices for all your needs.",

            },
            "buy-desktops-in-rawalpindi": {
                id: 7,
                title: "Computers in Rawalpindi",
                MetaTitle: "Desktop PC for Sale in Rawalpindi",
                MetaDescription: "Check out CPU in Rawalpindi and computer price in Rawalpindi. Find top computer deals and high-performance CPUs for your home or office."
            },
            "buy-desktops-in-karachi": {
                id: 3,
                title: "Computers in Karachi",
                MetaTitle: "Desktop PC for Sale in Karachi",
                MetaDescription: "Discover CPU in Karachi and computer price in Karachi. Find the latest computers for gaming, work, and personal use at competitive prices."
            },
        },
        price: {
            "buy-desktops-under-30000": {
                id: 30000,
                MetaTitle: "Desktop PC Under 30000 in Pakistan",
                MetaDescription: "Explore PCs under 30k in Pakistan. Find affordable and high-performance computers for work, gaming, and everyday use at unbeatable prices.",
                title: "Desktop Computers Under 30000"
            },
            "buy-desktops-under-50000": {
                id: 50000,
                MetaTitle: "Desktop PC Under 50000 in Pakistan",
                MetaDescription: "Browse PCs under 50k in Pakistan. Discover reliable and budget-friendly computers for work, gaming, and personal use with great deals.",
                title: "Desktop Computers Under 50000"
            },
            "buy-desktops-under-60000": {
                id: 60000,
                MetaTitle: "Desktop PC Under 60000 in Pakistan",
                MetaDescription: "Shop PCs under 60k in Pakistan. Find high-quality computers for gaming, work, and entertainment at competitive prices and great discounts.",
                title: "Desktop Computers Under 60000"
            },
            "buy-desktops-under-100000": {
                id: 100000,
                title: "Desktop Computers Under 100000",
                MetaTitle: "Desktop PC Under 100000 in Pakistan",
                MetaDescription: "Discover PCs under 100k in Pakistan. Shop top-performing computers for work, gaming, and home use with exceptional deals and prices."
            },
        },
    },
};


